namespace Core {

    interface HowToGetThereAirport {
        Code: string;
        Title: string;
    }

    interface HowToGetThereFlightOption {
        departureTitle: string;
        duration: string;
    };

    class HowToGetThere {

        destinationTitle: string;
        destinationAirports: string;
        options: HowToGetThereFlightOption[];

        constructor(
            flightStaticService: TR.FlightStaticService,
            private geo,
            private $q: ng.IQService
        ) {
            this.getDepartureAirports().then((departureAirports: HowToGetThereAirport[]) => {

                let departureAirportGroups = _.map(departureAirports, a => a.Code);
                let destinationAirportGroups = [this.destinationAirports];

                flightStaticService.getFlightDurations(departureAirportGroups, destinationAirportGroups)
                    .then((durations: TR.FlightDurationResponse[]) => {
                        this.options = _.chain(departureAirports)
                            .map(a => ({
                                a,
                                d: _.find(durations, d => d.DurationMinutesDepartureAirport === a.Code)
                            }))
                            .filter(tuple => tuple.d)
                            .map(tuple => {
                                let option: HowToGetThereFlightOption = {
                                    departureTitle: tuple.a.Title,
                                    duration: this.formatDuration(tuple.d.DurationMinutes)
                                };
                                return option;
                            })
                            .value();
                });
            });
        }

        getDepartureAirports() {
            if (TRPCONFIG.Domain.HowToGetThereDepartureAirports) {
                let departureAirports: HowToGetThereAirport[] =
                    angular.fromJson(TRPCONFIG.Domain.HowToGetThereDepartureAirports);
                return this.$q.when(departureAirports);
            }
            return this.geo.getNearestAirportTitles();
        }

        formatDuration(minutes: number): string {
            let hours: number = Math.floor(minutes / 60);
            let duration: string = hours > 0 ? (hours + 'h ') : '';
            duration += (minutes % 60) + 'm';
            return duration;
        }
    }

    angular
        .module('core')
        .directive('howToGetThere', (): ng.IDirective => {
            return {
                restrict: 'E',
                templateUrl: 'partials/home/directivetemplate?type=LandingPage/HowToGetThere',
                bindToController: {
                    destinationTitle: '@',
                    destinationAirports: '@'
                },
                scope: {},
                controller: HowToGetThere,
                controllerAs: 'ht'
            };
        });
}
